import { registerLicense } from "@syncfusion/ej2-base";
import variables from "@config/variables";
import Pages from "@/pages";
import {
  FieldSchemaV2FactoryProvider,
  flyoutContainerRegistry,
  FormFieldConfigContext,
  systemFieldConfig,
} from "@ucl/library";
import { apiClient } from "@/api/apiClient";
import { SanctionsMatchFlyout } from "@/components/SanctionsMatchFlyout";
import { AuthorizedCreditReportResultFlyout } from "@/components/AuthorizedCreditReportResultFlyout";
import "./App.scss";
import { BoltDocumentFileUploader } from "@bolt/document";

// Register Syncfusion License
registerLicense(variables.syncfusionLicenseKey);

// Register Flyouts
flyoutContainerRegistry.registerFlyouts([
  {
    key: "sanctions-match-flyout",
    component: SanctionsMatchFlyout,
    sidebarSettings: {
      position: "Right",
      width: "60%",
    },
  },
  {
    key: "authorized-credit-report-result-flyout",
    component: AuthorizedCreditReportResultFlyout,
    sidebarSettings: {
      position: "Right",
      width: "60%",
    },
  },
]);

function App() {
  return (
    <FieldSchemaV2FactoryProvider apiClient={apiClient}>
        <FormFieldConfigContext.Provider
          value={
            {
            fieldConfig: {
              ...systemFieldConfig,
              ...{
                File: BoltDocumentFileUploader,
              },
            },
            errorMessagesCount: 1,
            showRequiredFieldAsterisk: true,
          }}
        >
          <Pages />
        </FormFieldConfigContext.Provider>
    </FieldSchemaV2FactoryProvider>
  );
}

export default App;
